
  import '/Users/jilin/projects/antd/rc-dialog/assets/index.less?watch=parent';
  export default "@prefixCls: rc-dialog;\n\n@import \"./index/Dialog.less\";\n@import \"./index/Mask.less\";\n";;
  